(function () {

    let currentSubscriptionState = {
        isSubscription: false,
        frequency     : null,
        purchaseType  : 'onetime'
    };

    let selectedAddonData = null;

    function findElements() {
        return {
            productAddonsContainer: document.querySelector('.product-addons'),
            configEl              : document.querySelector('.product-addons__config'),
            productForm           : document.querySelector('.js-product-form'),
            productVariantRadios  : document.querySelectorAll('.product-form__swatch__input[name="size-b"]'),
            variantSelect         : document.querySelector('select[name="id"]'),
            addToCartButton       : document.querySelector('.js-product-add'),
            quantityContainer     : document.querySelector('.js-qty'),
            quantityInput         : document.querySelector('.js-qty-input') || document.querySelector('input[name="quantity"]'),
            plusButton            : document.querySelector('.js-qty__adjust--plus'),
            minusButton           : document.querySelector('.js-qty__adjust--minus'),
            rechargeWidget        : document.querySelector('recharge-subscription-widget'),
            addonDropdown         : document.querySelector('#addon-select'),
            addonTiles            : document.querySelectorAll('.product-addons__tile'),
            addonDetails          : document.querySelector('#addon-details'),
            addonCheckbox         : document.querySelector('#addon-checkbox')
        };
    }

    function getSelectedFrequency() {
        const elements       = findElements();
        const rechargeWidget = elements.rechargeWidget;

        if (!rechargeWidget || !rechargeWidget.shadowRoot) {
            return null;
        }

        const shadowRoot = rechargeWidget.shadowRoot;

        const sellingPlansComponent = shadowRoot.querySelector('rc-selling-plans');
        if (sellingPlansComponent) {

            if (sellingPlansComponent.shadowRoot) {

                const plansRoot = sellingPlansComponent.shadowRoot;

                const selectedButtons = plansRoot.querySelectorAll('.rc-plans-button__selected, [class*="selected"]');

                for (let button of selectedButtons) {
                    const frequencyText = button.textContent || button.innerText;

                    const match = frequencyText.match(/(\d+)\s*days?/i);
                    if (match) {

                        currentSubscriptionState.frequency = parseInt(match[1]);
                        return parseInt(match[1]);
                    }
                }

                const checkedRadios = plansRoot.querySelectorAll('input[type="radio"]:checked');

                for (let radio of checkedRadios) {
                    const label         = radio.closest('label') || radio.nextElementSibling;
                    const frequencyText = label?.textContent || radio.value;

                    const match = frequencyText.match(/(\d+)\s*days?/i);
                    if (match) {

                        currentSubscriptionState.frequency = parseInt(match[1]);
                        return parseInt(match[1]);
                    }
                }
            }
        }

        if (rechargeWidget.selectedVariantPlan) {
            const planData = rechargeWidget.selectedVariantPlan;

            if (planData.name) {
                const match = planData.name.match(/(\d+)\s*days?/i);
                if (match) {

                    return parseInt(match[1]);
                }
            }
            if (planData.delivery_interval_frequency) {

                return parseInt(planData.delivery_interval_frequency);
            }
        }

        if (rechargeWidget.variantPlans && rechargeWidget.variantPlans.length > 0) {
            const firstPlan = rechargeWidget.variantPlans[0];

            if (firstPlan.name) {
                const match = firstPlan.name.match(/(\d+)\s*days?/i);
                if (match) {

                    return parseInt(match[1]);
                }
            }
            if (firstPlan.delivery_interval_frequency) {

                return parseInt(firstPlan.delivery_interval_frequency);
            }
        }

        if (window.SubscriptionWidgetConfig && window.SubscriptionWidgetConfig.shopifyPlans && window.SubscriptionWidgetConfig.shopifyPlans.length > 0) {

            if (rechargeWidget.sellingPlanId) {
                const matchingPlan = window.SubscriptionWidgetConfig.shopifyPlans.find(
                    plan => plan.id === rechargeWidget.sellingPlanId
                );
                if (matchingPlan) {

                    const match = matchingPlan.name.match(/(\d+)\s*days?/i);
                    if (match) {

                        return parseInt(match[1]);
                    }
                }
            }

            const firstPlan = window.SubscriptionWidgetConfig.shopifyPlans[0];
            const match     = firstPlan.name.match(/(\d+)\s*days?/i);
            if (match) {

                return parseInt(match[1]);
            }
        }

        return null;
    }

    function checkSubscriptionSelection() {

        const elements       = findElements();
        const rechargeWidget = elements.rechargeWidget;

        if (!rechargeWidget) {

            return {
                isSubscription: false,
                frequency     : null,
                purchaseType  : 'onetime'
            };
        }

        if (!rechargeWidget.shadowRoot) {

            return currentSubscriptionState;
        }

        const shadowRoot = rechargeWidget.shadowRoot;

        const subscriptionOption = shadowRoot.querySelector('.rc-purchase-option__subscription[rc-selected]');
        if (subscriptionOption) {

            const frequency = getSelectedFrequency();
            return {
                isSubscription: true,
                frequency     : frequency,
                purchaseType  : 'subscription'
            };
        }

        const subscriptionRadio = shadowRoot.querySelector('input[name="purchaseOption"][value="subscription"]:checked');
        if (subscriptionRadio) {

            const frequency = getSelectedFrequency();
            return {
                isSubscription: true,
                frequency     : frequency,
                purchaseType  : 'subscription'
            };
        }

        const subscriptionSection = shadowRoot.querySelector('.rc-purchase-option__subscription');
        if (subscriptionSection) {
            const checkedIcon = subscriptionSection.querySelector('rc-radio-icon[checked]');
            if (checkedIcon) {

                const frequency = getSelectedFrequency();
                return {
                    isSubscription: true,
                    frequency     : frequency,
                    purchaseType  : 'subscription'
                };
            }
        }

        const onetimeOption         = shadowRoot.querySelector('.rc-selection__onetime[rc-not-selected]');
        const hasSubscriptionOption = shadowRoot.querySelector('.rc-purchase-option__subscription');
        if (onetimeOption && hasSubscriptionOption && !hasSubscriptionOption.hasAttribute('rc-not-selected')) {

            const frequency = getSelectedFrequency();
            return {
                isSubscription: true,
                frequency     : frequency,
                purchaseType  : 'subscription'
            };
        }

        if (rechargeWidget.purchaseOption === 'subscription') {

            const frequency = getSelectedFrequency();
            return {
                isSubscription: true,
                frequency     : frequency,
                purchaseType  : 'subscription'
            };
        }

        return {
            isSubscription: false,
            frequency     : null,
            purchaseType  : 'onetime'
        };
    }

    function updateSubscriptionState() {
        const newState   = checkSubscriptionSelection();
        const hasChanged =
                  currentSubscriptionState.isSubscription !== newState.isSubscription ||
                  currentSubscriptionState.frequency !== newState.frequency ||
                  currentSubscriptionState.purchaseType !== newState.purchaseType;

        if (hasChanged) {

            const previousState      = {...currentSubscriptionState};
            currentSubscriptionState = newState;

            const event = new CustomEvent('subscriptionStateChanged', {
                detail: {
                    isSubscription: newState.isSubscription,
                    frequency     : newState.frequency,
                    purchaseType  : newState.purchaseType,
                    previousState : previousState
                }
            });
            document.dispatchEvent(event);

            updateAddonQuantities();
            updateAddonUI();
        }

        return newState;
    }

    function updateAddonUI() {

        const state           = getCurrentSubscriptionState();
        const addonsContainer = document.querySelector('.product-addons');

        if (!addonsContainer) {

            return;
        }

        if (state.isSubscription) {
            addonsContainer.classList.add('product-addons--subscription-active');
        } else {
            addonsContainer.classList.remove('product-addons--subscription-active');
        }

        const subscriptionBadge = document.querySelector('#addon-subscription-badge');
        if (subscriptionBadge) {
            if (state.isSubscription) {
                subscriptionBadge.classList.remove('subscription-badge--hidden');
                if (state.frequency) {
                    subscriptionBadge.textContent = `Every ${state.frequency} days`;
                } else {
                    subscriptionBadge.textContent = 'Subscription';
                }
            } else {
                subscriptionBadge.classList.add('subscription-badge--hidden');
            }
        }
    }

    function updateAddonDetails(addonData) {
        const elements = findElements();

        if (!addonData || !addonData.productId) {
            elements.addonDetails.classList.remove('product-addons__details--visible');
            selectedAddonData = null;
            return;
        }

        selectedAddonData = addonData;

        const addonImage             = document.querySelector('#addon-image');
        const addonTitle             = document.querySelector('#addon-title');
        const addonPriceOnetime      = document.querySelector('#addon-price-onetime');
        const addonPriceSubscription = document.querySelector('#addon-price-subscription');
        const addonQuantity          = document.querySelector('#addon-quantity');

        if (addonData.image) {
            addonImage.innerHTML = `<img src="${addonData.image}" alt="${addonData.title}" loading="lazy">`;
        }

        if (addonTitle) {
            addonTitle.textContent = addonData.title;
        }
        if (addonPriceOnetime) {
            addonPriceOnetime.textContent = formatPrice(addonData.price);
        }
        if (addonPriceSubscription) {
            addonPriceSubscription.textContent = formatPrice(addonData.subscriptionPrice);
        }
        if (addonQuantity) {
            addonQuantity.textContent = addonData.quantity || '1';
        }

        elements.addonDetails.classList.add('product-addons__details--visible');
        updateAddonQuantities();
    }

    function formatPrice(priceInCents) {
        if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
            return Shopify.formatMoney(priceInCents);
        }
        return '$' + (priceInCents / 100).toFixed(2);
    }

    function observeRechargeWidget() {
        const elements       = findElements();
        const rechargeWidget = elements.rechargeWidget;

        if (!rechargeWidget) {

            setTimeout(observeRechargeWidget, 500);
            return;
        }

        const waitForShadowRoot = () => {
            if (rechargeWidget.shadowRoot) {

                setupShadowRootObserver(rechargeWidget.shadowRoot);
                setTimeout(() => {
                    updateSubscriptionState();
                }, 100);
            } else {

                setTimeout(waitForShadowRoot, 100);
            }
        };

        waitForShadowRoot();
    }

    function setupShadowRootObserver(shadowRoot) {
        const observer = new MutationObserver((mutations) => {
            let shouldUpdate = false;

            mutations.forEach((mutation) => {
                if (mutation.type === 'attributes' &&
                    (mutation.attributeName === 'rc-selected' ||
                     mutation.attributeName === 'rc-not-selected' ||
                     mutation.attributeName === 'checked' ||
                     mutation.attributeName === 'selected')) {
                    shouldUpdate = true;
                }

                if (mutation.type === 'attributes' &&
                    mutation.target.type === 'radio' &&
                    mutation.attributeName === 'checked') {
                    shouldUpdate = true;
                }

                if (mutation.type === 'attributes' &&
                    mutation.attributeName === 'class' &&
                    (mutation.target.className.includes('selected') ||
                     mutation.target.className.includes('rc-plans-button'))) {
                    shouldUpdate = true;
                }
            });

            if (shouldUpdate) {

                setTimeout(updateSubscriptionState, 50);
            }
        });

        observer.observe(shadowRoot, {
            childList      : true,
            subtree        : true,
            attributes     : true,
            attributeFilter: ['rc-selected', 'rc-not-selected', 'checked', 'class', 'selected']
        });

        shadowRoot.addEventListener('click', (e) => {
            if (e.target.matches('input[name="purchaseOption"], .rc-purchase-option__label, rc-radio-icon, .rc-plans-button, [class*="plan"], rc-selling-plans *')) {

                setTimeout(updateSubscriptionState, 10);
            }
        });

        const checkSellingPlans = () => {
            const sellingPlansComponent = shadowRoot.querySelector('rc-selling-plans');
            if (sellingPlansComponent) {

                const plansObserver = new MutationObserver(() => {

                    setTimeout(updateSubscriptionState, 50);
                });

                plansObserver.observe(sellingPlansComponent, {
                    childList : true,
                    subtree   : true,
                    attributes: true
                });

                sellingPlansComponent.addEventListener('click', () => {

                    setTimeout(updateSubscriptionState, 10);
                });

                if (sellingPlansComponent.shadowRoot) {
                    plansObserver.observe(sellingPlansComponent.shadowRoot, {
                        childList : true,
                        subtree   : true,
                        attributes: true
                    });
                }
            } else {
                setTimeout(checkSellingPlans, 100);
            }
        };

        checkSellingPlans();

    }

    function getCurrentSubscriptionState() {
        return {...currentSubscriptionState};
    }

    function getAddonSellingPlanId(addonProductId, frequency) {

        const configEl = document.querySelector('.product-addons__config');
        let config     = {addonSellingPlans: {}};

        if (configEl) {
            try {
                config = JSON.parse(configEl.textContent);
            } catch (error) {
                console.error('Error parsing addon configuration:', error);
            }
        }

        if (!config.addonSellingPlans || !config.addonSellingPlans[addonProductId]) {
            console.warn(`No selling plans found for addon product ${addonProductId}`);
            return null;
        }

        const addonPlans    = config.addonSellingPlans[addonProductId];
        const frequencyKey  = `${frequency}-days`;
        const sellingPlanId = addonPlans[frequencyKey];

        console.log(`Looking for selling plan with key "${frequencyKey}":`, sellingPlanId);
        return sellingPlanId || null;
    }

    function initProductAddons() {

        const elements = findElements();

        let config = {
            multipliers      : {3: 3, 5: 5, 7: 7},
            addonSellingPlans: {}
        };

        if (elements.configEl) {
            try {
                config = JSON.parse(elements.configEl.textContent);

            } catch (error) {
                console.error('Error parsing addon configuration:', error);
            }
        }

        observeRechargeWidget();

        document.addEventListener('subscriptionStateChanged', (e) => {

            updateAddonUI();
        });

        updateAddonQuantities();

        setupVariantChangeListeners();

        const lengthRadios = document.querySelectorAll('input[name="length-b"]');
        lengthRadios.forEach(radio => {
            radio.addEventListener('change', updateAddonQuantities);
        });

        if (elements.plusButton) {
            elements.plusButton.addEventListener('click', () => {
                setTimeout(updateAddonQuantities, 10);
            });
        }
        if (elements.minusButton) {
            elements.minusButton.addEventListener('click', () => {
                setTimeout(updateAddonQuantities, 10);
            });
        }
        if (elements.quantityInput) {
            elements.quantityInput.addEventListener('change', updateAddonQuantities);
            elements.quantityInput.addEventListener('input', updateAddonQuantities);
        }

        setupAddToCartFunctionality();

        initWellnessShotDropdown();

    }

    function setupAddToCartFunctionality() {
        const elements = findElements();

        if (!elements.addToCartButton) {

            return;
        }

        const newButton = elements.addToCartButton.cloneNode(true);
        elements.addToCartButton.parentNode.replaceChild(newButton, elements.addToCartButton);

        newButton.addEventListener('click', async (e) => {
                e.preventDefault();
                e.stopPropagation();

                let selectedVariant;
                const updatedElements = findElements();

                if (updatedElements.variantSelect) {
                    selectedVariant = updatedElements.variantSelect.value;
                } else {
                    console.error('No variant select found');
                    alert('Please select a product variant.');
                    return;
                }

                if (!selectedVariant) {
                    alert('Please select a product variant.');
                    return;
                }

                const quantity          = parseInt(updatedElements.quantityInput?.value || 1);
                const subscriptionState = getCurrentSubscriptionState();

                const isSubscription    = subscriptionState.isSubscription;
                const selectedFrequency = subscriptionState.frequency;

                let mainSellingPlanId          = null;
                let variantSupportsSellingPlan = false;

                const productJsonEl = document.querySelector('[id^="ProductJson-"]');
                if (productJsonEl) {
                    try {
                        const productData = JSON.parse(productJsonEl.textContent);
                        const variant     = productData.variants?.find(v => String(v.id) === String(selectedVariant));
                        if (variant && variant.selling_plan_allocations && variant.selling_plan_allocations.length > 0) {
                            variantSupportsSellingPlan = true;
                        }
                    } catch (e) {
                        console.warn('Could not parse product JSON for selling plan check:', e);
                    }
                }

                if (isSubscription && variantSupportsSellingPlan) {
                    const rechargeWidget = document.querySelector('recharge-subscription-widget');
                    if (rechargeWidget && rechargeWidget.sellingPlanId) {
                        mainSellingPlanId = rechargeWidget.sellingPlanId;

                    } else if (window.SubscriptionWidgetConfig?.shopifyPlans?.length > 0) {
                        const matchingPlan = selectedFrequency
                                             ? window.SubscriptionWidgetConfig.shopifyPlans.find(plan =>
                                plan.name.toLowerCase().includes(`${selectedFrequency} day`))
                                             : window.SubscriptionWidgetConfig.shopifyPlans[0];
                        mainSellingPlanId  = matchingPlan?.id;

                    }
                }

                const cartItems = [];

                const mainItem = {
                    id      : selectedVariant,
                    quantity: quantity
                };

                if (isSubscription && mainSellingPlanId && variantSupportsSellingPlan) {
                    mainItem.selling_plan = mainSellingPlanId;
                }

                cartItems.push(mainItem);

                const checkedAddons = document.querySelectorAll('.product-addons__checkbox:checked');

                checkedAddons.forEach((checkbox, index) => {
                    const addonVariantId = checkbox.dataset.variantId;
                    const addonQuantity  = parseInt(checkbox.dataset.quantity || '1');
                    const addonProductId = getAddonProductId(checkbox);

                    console.log(`Addon ${index + 1}:`, {
                        addonVariantId,
                        addonQuantity,
                        addonProductId
                    });

                    if (!addonVariantId) {
                        console.error('Addon variant ID missing for checkbox:', checkbox);
                        return;
                    }

                    const addonItem = {
                        id      : addonVariantId,
                        quantity: addonQuantity
                    };

                    if (isSubscription && selectedFrequency && addonProductId) {
                        const addonSellingPlanId = getAddonSellingPlanId(addonProductId, selectedFrequency);
                        if (addonSellingPlanId) {
                            addonItem.selling_plan = addonSellingPlanId;
                            console.log(`Addon selling plan ID: ${addonSellingPlanId}`);
                        } else {
                            console.warn(`No selling plan found for addon ${addonProductId} with frequency ${selectedFrequency}`);
                        }
                    }

                    cartItems.push(addonItem);
                });

                if (cartItems.length === 0) {
                    alert('Please select items to add to cart.');
                    return;
                }

                const originalText = newButton.querySelector('.js-product-add-text')?.textContent || 'Add to Cart';
                const addText      = newButton.querySelector('.js-product-add-text');
                if (addText) {
                    addText.textContent = 'Adding...';
                }
                newButton.disabled = true;

                try {
                    const response = await fetch('/cart/add.js', {
                        method : 'POST',
                        headers: {
                            'Content-Type'    : 'application/json',
                            'X-Requested-With': 'XMLHttpRequest'
                        },
                        body   : JSON.stringify({items: cartItems})
                    });

                    if (!response.ok) {
                        const errorText = await response.text();
                        console.error('Cart add response not ok:', response.status, errorText);
                        throw new Error(`HTTP error! status: ${response.status} - ${errorText}`);
                    }

                    const data = await response.json();

                    if (addText) {
                        addText.textContent = originalText;
                    }
                    newButton.disabled = false;

                    if (isSubscription) {
                        const rebuyEvent = new CustomEvent('rebuy:add-to-cart', {
                            detail: {
                                items : cartItems,
                                silent: true  // This adds items silently without opening the cart
                            }
                        });
                        window.dispatchEvent(rebuyEvent);
                        window.location.href = '/cart';
                    } else {
                        const rebuyEvent = new CustomEvent('rebuy:add-to-cart', {
                            detail: {items: cartItems}
                        });

                        window.dispatchEvent(rebuyEvent);

                        setTimeout(() => {
                            const cartDrawerTrigger = document.querySelector('[data-cart-drawer-trigger]') ||
                                                      document.querySelector('.js-drawer-open-cart') ||
                                                      document.querySelector('[data-drawer-trigger="cart"]');

                            if (cartDrawerTrigger) {
                                cartDrawerTrigger.click();
                            }
                        }, 500);
                    }

                } catch (error) {
                    console.error('Error adding to cart:', error);

                    if (addText) {
                        addText.textContent = originalText;
                    }
                    newButton.disabled = false;

                    alert('Unable to add items to cart. Please try again.');
                }
            }
        )
        ;

    }

    function getAddonProductId(checkbox) {
        const addonItem = checkbox.closest('.product-addons__item');
        let addonId     = null;

        if (addonItem && addonItem.classList.contains('wellness-shot-addon')) {
            addonId = addonItem.dataset.addonId;
        } else if (addonItem && addonItem.dataset.addonId) {
            addonId = addonItem.dataset.addonId;
        } else if (checkbox.dataset.productId) {
            addonId = checkbox.dataset.productId;
        } else if (checkbox.dataset.addonId) {
            addonId = checkbox.dataset.addonId;
        }

        return addonId;
    }

    function getSelectedVariantMetafield() {
        const elements        = findElements();
        let selectedVariantId = null;

        if (elements.variantSelect) {
            selectedVariantId = elements.variantSelect.value;
        } else {

            const selectedRadio = document.querySelector('input[name="id"]:checked');
            if (selectedRadio) {
                selectedVariantId = selectedRadio.value;
            }
        }

        if (!selectedVariantId) {
            console.error('No variant selected');
            return null;
        }

        const productMetafields = window.variantMetafields || [];
        const variantData       = productMetafields.find(v => v.id == selectedVariantId);

        if (variantData && variantData.metafields && variantData.metafields.product_cross_sell) {
            const addOnCount = variantData.metafields.product_cross_sell.add_on_count;

            return parseInt(addOnCount) || 1;
        }

        return null;
    }

    function updateAddonQuantities() {

        const elements            = findElements();
        const quantityInput       = elements.quantityInput;
        const mainProductQuantity = parseInt(quantityInput?.value || 1);

        let addonMultiplier = getSelectedVariantMetafield();

        if (addonMultiplier === null || isNaN(addonMultiplier)) {

            const selectedVariantRadio = document.querySelector('input[name="length-b"]:checked');
            if (selectedVariantRadio) {
                const match = selectedVariantRadio.value.match(/(\d+)\s*Day/i);
                if (match) {
                    addonMultiplier = parseInt(match[1]);

                }
            }

            if (!addonMultiplier || isNaN(addonMultiplier)) {
                addonMultiplier = 1;

            }
        }

        document.querySelectorAll('.product-addons__item').forEach(addonItem => {
            const quantitySpan = addonItem.querySelector('.quantity-value');
            const checkbox     = addonItem.querySelector('.product-addons__checkbox');

            if (quantitySpan && checkbox) {

                const finalQuantity = addonMultiplier * mainProductQuantity;
                console.log(finalQuantity);
                quantitySpan.textContent  = String(finalQuantity);
                checkbox.dataset.quantity = String(finalQuantity);

            }
        });

    }

    function setupVariantChangeListeners() {

        const elements = findElements();

        if (elements.variantSelect) {
            elements.variantSelect.addEventListener('change', function (e) {

                setTimeout(() => {
                    updateAddonQuantities();
                }, 50);
            });
        }

        const variantRadios = document.querySelectorAll('input[name="id"]');
        variantRadios.forEach(radio => {
            radio.addEventListener('change', function (e) {
                if (e.target.checked) {

                    setTimeout(() => {
                        updateAddonQuantities();
                    }, 50);
                }
            });
        });

        const swatchInputs = document.querySelectorAll('.product-form__swatch__input');
        swatchInputs.forEach(input => {
            input.addEventListener('change', function (e) {

                setTimeout(() => {
                    updateAddonQuantities();
                }, 100);
            });
        });

        document.addEventListener('variantChanged', function (e) {

            setTimeout(() => {
                updateAddonQuantities();
            }, 100);
        });

        document.addEventListener('variant:change', function (e) {

            setTimeout(() => {
                updateAddonQuantities();
            }, 100);
        });

        if (elements.variantSelect) {
            const observer = new MutationObserver(function (mutations) {
                mutations.forEach(function (mutation) {
                    if (mutation.type === 'attributes' && mutation.attributeName === 'value') {

                        setTimeout(() => {
                            updateAddonQuantities();
                        }, 50);
                    }
                });
            });

            observer.observe(elements.variantSelect, {
                attributes     : true,
                attributeFilter: ['value']
            });
        }
    }

    function tryInitialize() {

        const elements = findElements();

        if (elements.productVariantRadios.length || elements.variantSelect) {
            initProductAddons();
            initWellnessShotDropdown();
        } else {

            setTimeout(tryInitialize, 100);
        }
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', tryInitialize);
    } else {
        tryInitialize();
    }

    function initWellnessShotDropdown() {
        const dropdown = document.querySelector('[data-wellness-dropdown]');
        if (!dropdown) {
            return;
        }

        dropdown.addEventListener('change', function (e) {
            const selectedOption = e.target.selectedOptions[0];
            const addonItem      = document.querySelector('.wellness-shot-addon');

            if (!selectedOption || !addonItem) {
                return;
            }

            addonItem.dataset.addonId                = selectedOption.value;
            addonItem.dataset.addonHandle            = selectedOption.dataset.handle;
            addonItem.dataset.addonPrice             = selectedOption.dataset.price;
            addonItem.dataset.addonSubscriptionPrice = selectedOption.dataset.subscriptionPrice;

            const image = addonItem.querySelector('.wellness-shot-image');
            if (image && selectedOption.dataset.imageUrl && selectedOption.dataset.imageUrl !== 'null') {
                image.src = selectedOption.dataset.imageUrl;
                image.alt = selectedOption.text;
            }

            const title = addonItem.querySelector('.wellness-shot-title');
            if (title) {
                title.textContent = selectedOption.text;
            }

            const onetimePrice      = addonItem.querySelector('.wellness-shot-price');
            const subscriptionPrice = addonItem.querySelector('.wellness-shot-subscription-price');

            if (onetimePrice) {
                const price              = parseInt(selectedOption.dataset.price);
                onetimePrice.textContent = formatPrice(price);
            }

            if (subscriptionPrice) {
                const subPrice                = parseInt(selectedOption.dataset.subscriptionPrice);
                subscriptionPrice.textContent = formatPrice(subPrice);
            }

            const checkbox = addonItem.querySelector('.product-addons__checkbox');
            if (checkbox) {
                checkbox.dataset.variantId         = selectedOption.dataset.variantId;
                checkbox.dataset.price             = selectedOption.dataset.price;
                checkbox.dataset.subscriptionPrice = selectedOption.dataset.subscriptionPrice;
                checkbox.id                        = `wellness-shot-addon-${selectedOption.value}`;
            }

            const label = addonItem.querySelector('.product-addons__label');
            if (label) {
                label.setAttribute('for', `wellness-shot-addon-${selectedOption.value}`);
            }

        });
    }

    window.getCurrentSubscriptionState = getCurrentSubscriptionState;
    window.updateSubscriptionState     = updateSubscriptionState;
    window.checkSubscriptionSelection  = checkSubscriptionSelection;
    window.getSelectedFrequency        = getSelectedFrequency;
    window.initProductAddons           = initProductAddons;

    document.addEventListener('DOMContentLoaded', function () {
        const addonItems = document.querySelectorAll('.product-addons__item');

        addonItems.forEach(item => {
            item.addEventListener('click', function (e) {
                if (e.target.matches('input[type="checkbox"], label, select, option')) {
                    return;
                }

                const checkbox = item.querySelector('.product-addons__checkbox');
                if (checkbox) {
                    checkbox.checked = !checkbox.checked;

                    checkbox.dispatchEvent(new Event('change', {bubbles: true}));
                }
            });

            item.style.cursor = 'pointer';
        });
    });
})
();
